import { c as _c } from "react/compiler-runtime";
import { keysOf } from 'betterplace-utils';
import { useMemo } from 'react';
import { useDonationFormContext } from '@/donationPages/_dependencies/helpers';
const exludeKeys = new Set(['payment_method', '_captcha_complete', 'captcha_solution', '_layout', 'channel', '']);
function useFieldErrorsKeys() {
  const $ = _c(2);
  const {
    formState
  } = useDonationFormContext();
  const {
    errors
  } = formState;
  let t0;
  if ($[0] !== errors) {
    t0 = keysOf(errors ?? {}).filter(_temp);
    $[0] = errors;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const keys = t0;
  return keys;
}

/**
 * Function skips the "general" payment_method error, so that we only evaluate the validity of the field itself
 * @returns boolean
 */
function _temp(key) {
  return !exludeKeys.has(key);
}
function useIsFormValid() {
  const {
    formState
  } = useDonationFormContext();
  const {
    isValid
  } = formState;
  const keys = useFieldErrorsKeys();
  return isValid || !keys.length;
}
export default useIsFormValid;